import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const validityDefinition: ResourceDefinition = {
  title: 'Validities',
  nameSingular: 'Validity',
  namePlural: 'Validities',
  className: 'Validity',
  mainIdentifier: 'name',
  slug: 'taxonomies/validities',
  path: 'validities',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (validity) => ({
        type: ActionType.Link,
        link: {
          path: `${validityDefinition.path}/${validity.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (validity) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: validity,
          definition: validityDefinition
        }
      })
    }
  ]
}
